import { render, staticRenderFns } from "./DeleteRoleConfirmationDialog.vue?vue&type=template&id=513829c8"
import script from "./DeleteRoleConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteRoleConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports